import { spawn } from 'redux-saga/effects';

import { sagas as create } from './createModule';
import { sagas as details } from './detailsModule';
import { sagas as list } from './listModule';
import { sagas as possibleNodes } from './possibleNodesModule';
import { sagas as available } from './availableModule';
import { sagas as update } from './updateModule';
import { sagas as strategies } from './strategiesModule';

export default function* sagas() {
	yield spawn(create);
	yield spawn(details);
	yield spawn(list);
	yield spawn(possibleNodes);
	yield spawn(available);
	yield spawn(update);
	yield spawn(strategies);
}
